/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_PROD,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.PROD,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.PROD,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.PROD,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.PROD,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.PROD_APP_ID,
      appCode: HereMapsCredentials.PROD_APP_CODE,
      useCIT: false
    }
  }
};

export default config;
